import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { ReactNode } from 'react';
import CustomRichText from '../CustomRichText';

export interface ProposalCardProps {
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  color?: 'violet' | 'green' | 'blue';
}
function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(' ');
}

export default function ProposalCard_V2({ title, subtitle, color = 'green' }: ProposalCardProps) {
  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn-h',
      blue: 'custom-gradient-blue-btn-h',
      violet: 'custom-gradient-violet-btn-h',
    }[color] || 'custom-gradient-green-btn-h';
  return (
    <div
      data-meta="ProposalCard_V2"
      className={`flex p-4 xl:p-8 backdrop-blur-sm bg-white/30 rounded-3xl`}
    >
      <div className={'flex items-start justify-center text-white'}></div>
      <div
        className={classNames(
          subtitle ? 'lg:items-start justify-start' : 'lg:items-center',
          'text-white flex flex-col items-center justify-start w-full',
        )}
      >
        <CustomRichText
          data={title}
          tag="div"
          className={classNames('mb-6', 'text-xl font-bold')}
        />
        {subtitle && <CustomRichText data={subtitle} tag="div" />}
      </div>
    </div>
  );
}
